import { getAdminAxiosInstance } from "../../../api/Admin";

/**
 * One entry point for both create and update - the admin service routes on the presence of
 * plan_id, so there is no separate update path to call.
 *
 * Editing a *published* plan does not rewrite it: the cart service supersedes it with a new
 * version and returns the successor's id, which the caller has to adopt.
 */
export const createAndUpdateSubscriptionPlan = async (params) => {
  const api = await getAdminAxiosInstance();
  try {
    const response = await api.post(`/subscription-plan/create`, params);
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const deleteSubscriptionPlan = async (id) => {
  const api = await getAdminAxiosInstance();
  try {
    const response = await api.get(`/subscription-plan/delete?plan_id=${id}`);
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};
